import axios from "axios";
import { ExtractErrorInformation } from "components/MprcRequestErrorReport";
import { PlayerMode, ScoComponentDto, ScormPlayerAccessTokenQuery, TrainingScormPlayerWindowOption } from "generated/CoreApi_v1";
import HtmlUtils from "lib/HtmlUtils";
import { SessionService } from "services/sessionService";


export class ScormPlayerService {

    static getToken(p: ScormPlayerAccessTokenQuery): Promise<string | null> {
        return axios.post<string | null>
            (
                SessionService.current.apiPaths.coreApi + "/api/v1.0/cds/GetScormPlayerToken"
                , p
                , { withCredentials: true }
            )
            .then((res) => {
                return res.data ?? null;
            });
    }

    static openCdsPlayer(
        enrollmentId: string,
        sco: ScoComponentDto,
    ): Promise<Window | null> {
        return this.internalOpenCdsPlayer(sco.scoId, enrollmentId, PlayerMode.Normal, sco.windowOption, sco.windowWidth, sco.windowHeight);
    }

    static openCdsPlayerReview(
        enrollmentId: string,
        sco: ScoComponentDto,
    ): Promise<Window | null> {
        return this.internalOpenCdsPlayer(sco.scoId, enrollmentId, PlayerMode.Review, sco.windowOption, sco.windowWidth, sco.windowHeight);
    }

    static openCdsPlayerDemo(
        scoId: string,
        windowOption: TrainingScormPlayerWindowOption,
        windowWidth?: number | null,
        windowHeight?: number | null
    ): Promise<Window | null> {
        return this.internalOpenCdsPlayer(scoId, null, PlayerMode.Demo, windowOption, windowWidth, windowHeight);
    }

    private static async internalOpenCdsPlayer(
        scoId: string,
        enrollmentId: string | null,
        playerMode: PlayerMode,
        windowOption: TrainingScormPlayerWindowOption,
        windowWidth?: number | null,
        windowHeight?: number | null
    ): Promise<Window | null> {

        const maximize = windowOption === TrainingScormPlayerWindowOption.Maximized;

        try {
            var token = await this.getToken({ enrollmentId, scoId, playerMode });
            if (token == null) return null;

            var p: string[] = [];
            p.push("token=" + token);

            var f: Array<string> = [];
            f.push("toolbar=no");
            f.push("menubar=no");

            if (windowWidth || windowHeight || maximize)
                f.push("resizable=no");

            if (maximize === true) {
                f.push(`width=${window.screen.availWidth}px`);
                f.push(`height=${window.screen.availHeight}px`);
                f.push("top=0");
            }
            else {
                if (windowWidth) f.push(`width=${windowWidth}`);
                if (windowHeight) f.push(`height=${windowHeight}`);
                if (windowWidth && windowHeight) {
                    // Centraliza
                    f.push(`left=${(window.screen.availWidth - windowWidth) / 2}`);
                    f.push(`top=${(window.screen.availHeight - windowHeight) / 2}`);
                }
            }

            const w = window.open(HtmlUtils.getFullLocation() + "/CdsPlayer?" + p.join("&"), scoId, f.join(","));

            return w;
        }
        catch (e: any) {
            var error = ExtractErrorInformation(e);
            if (error.message) alert(error.message);
        }
        return null;
    }
}
